module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./BeanRulerView.js"));
	}, "BeanHomeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BeanHomeView!./src/pages/PunchClock/Bean/BeanRuler/BeanRulerView.js
// module id = 1279
// module chunks = 431